import { useEffect, useState } from "react";

import {
    AdditionalDataValue,
    ChangeOrderParams,
    ORDER
} from "../SecondSelectContent/InternalLog/types";
import { SelectedTask } from "../types/types";

const useInternalLog = (selectedTask: SelectedTask) => {
    const [order, setOrder] = useState(ORDER.Newest);
    const [inputValue, setInputValue] = useState<AdditionalDataValue>(null);

    useEffect(() => {
        setOrder(ORDER.Newest);
        setInputValue(null);
    }, [selectedTask?.type]);

    const changeOrder = (e: ChangeOrderParams) => {
        const value = e.target.value as ORDER;

        setInputValue(null);
        setOrder(value);
    };

    const changeInputValue = (value: AdditionalDataValue) =>
        setInputValue(value);

    return {
        additionalData: { order, inputValue },
        changeOrder,
        changeInputValue
    };
};

export { useInternalLog };
